import React from "react";
import { Helmet } from "react-helmet";
import { PageBanner, BigHeading, Tickertape, Lineup } from "../components";
import { StrokeText } from "../components";

/* Lineup Page
============================================================================= */

const LineupPage = () => {
	// Config

	// Render
	return (
		<>
			<Helmet>
				<title>Lineup</title>
			</Helmet>
			<PageBanner />
			<Tickertape />
			<BigHeading text="Lineup" />
			<div className="flex flex-row items-center justify-center pb-2">
				<StrokeText
					text="In Alphabetical Order"
					size="xl:text-2xl text-xl text-center"
				/>
			</div>
			<Lineup />
		</>
	);
};

/* Export
============================================================================= */

export default LineupPage;
